import React, { useRef } from 'react';
import styled from 'styled-components';
import AccordionMenu from '@westwing/ui-kit/Accordion';
import { body1 } from '@westwing/ui-kit/typography';

const TitleMobile = styled.span`
    ${body1}
`;

const StyledAccordionMenu = styled(AccordionMenu)`
    border-top: 0;
    border-bottom: 1px solid ${({ theme }) => theme.colors.charcoal20New};
    box-sizing: border-box;
`;

const AccordionContentWrapper = styled.div`
    margin: 15px 0 32px;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
`;

const FooterLinksAccordion: React.FC<{
    track?: (trackingAction: string) => void;
    title: string;
    accordionTrackingActions?: {
        open: string;
        close: string;
    };
}> = ({ track, title, accordionTrackingActions, children }) => {
    // For tracking Accordion open/close
    const isAccordionOpen = useRef<boolean>(false);

    const trackAccordion = () => {
        if (track && accordionTrackingActions) {
            track(isAccordionOpen.current ? accordionTrackingActions.close : accordionTrackingActions.open);

            isAccordionOpen.current = !isAccordionOpen.current;
        }
    };

    return (
        <StyledAccordionMenu renderTitle={() => <TitleMobile>{title}</TitleMobile>} clickHandler={trackAccordion}>
            <AccordionContentWrapper>{children}</AccordionContentWrapper>
        </StyledAccordionMenu>
    );
};

export default FooterLinksAccordion;
